<template>
  <div class="zan-loading"></div>
</template>

<script>
export default {
  name: 'zan-loading'
};
</script>



// WEBPACK FOOTER //
// loading.vue?20a97269